let path = "https://gallery.kestoneapps.in";
if (process.env.NODE_ENV === "development") {
  path = "http://localhost:5079";
}
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
};
export const basePath = path;
export const apiPath = basePath + "/api";
export const apiLoginUser = "/auth/login";
export const apiLogutUser = "/auth/logout";
export const apiGetUser = "/auth/profile";
export const apiRegisterUser = "/auth/register";
export const apiWidgets = "/widget";
export const apiCreateFolder = "/folders";
export const apiListFolders = "/folders/list";
export const apiUploadFiles = "/files/upload";
export const apiPreflightUpload = "/files/preflight";
export const apiGetFilesByFolder = "/files/folder";
export const apiDownloadFolderZip = "/files/folder";
export const apiDeleteFile = "/files";
export const apiShareFolder = "/shares";
export const apiBulkShareFolder = "/shares/bulk";
export const apiGetFolderShares = "/shares/folder";
export const apiSharedWithMe = "/shares/shared-with-me";
export const apiValidateShareToken = "/shares/public";
export const apiTrackDownload = "/shares/public";
export const apiClaimOpenShare = "/shares/public";
export const apiShareActivity = "/shares/activity";
export const apiFaceProcess = "/face/process";
export const apiFaceMyPhotos = "/face/my-photos";
export const apiFaceMyPhotosResult = "/face/my-photos/result";
export const apiFaceMyPhotosUseProfile = "/face/my-photos/use-profile";
export const apiProfileImage = "/auth/profile/image";
export const apiDashboardStats = "/dashboard/stats";
export const apiDashboardRecentFolders = "/dashboard/recent-folders";
export const apiDashboardRecentUploads = "/dashboard/recent-uploads";
export const apiDashboardActivity = "/dashboard/activity";
export const apiDashboardUploadChart = "/dashboard/upload-chart";
